import React, { Component, createRef } from 'react';
import { Form, Field, FormSpy } from 'react-final-form';
import classnames from 'classnames';
import { connect } from 'react-redux';
import { PureTextField } from './fields/text';
import { localeSelector, messagesSelector } from '../../helpers/selectors';
import { safe } from '../../utils/utils';
import { setFormValues } from '../../actions/formMirror';

/**
 * @typedef {object} ChorusFieldsFormProps
 * @property {Function} [passFormSubmit]
 * @property {object} [initialValues=null]
 */
class ChorusFieldsForm extends Component {
  constructor(props) {
    super(props);
    this.formApiRef = createRef();
  }

  componentDidMount() {
    this.registerPassFormSubmit();
  }

  registerPassFormSubmit() {
    const { passFormSubmit } = this.props;

    if (passFormSubmit) {
      passFormSubmit((action) => {
        const values = this.formApiRef.current
          ? this.formApiRef.current.getState().values
          : {};

        action(values);
      });
    }
  }

  getChorusFields() {
    const { initialValues, m } = this.props;

    if (safe(() => initialValues.administration)) {
      return (
        <div className="specificities">
          <div className="scope-confirm-recap-sub-title">
            {m['members_detail_enterprise_chorus_detail']}
          </div>

          <Field
            name="chorusAlias"
            label={m['members_detail_enterprise_chorus_chorusAlias']}
            component={PureTextField}
          />
          <Field
            name="chorusEngagement"
            label={m['members_detail_enterprise_chorus_chorusEngagement']}
            component={PureTextField}
          />
          <Field
            name="chorusMarche"
            label={m['members_detail_enterprise_chorus_chorusMarche']}
            component={PureTextField}
          />
          <Field
            name="chorusService"
            label={m['members_detail_enterprise_chorus_chorusService']}
            component={PureTextField}
          />
        </div>
      );
    }
  }

  render() {
    const { initialValues, dispatch } = this.props;

    return (
      <Form onSubmit={() => {}} initialValues={initialValues}>
        {({ form }) => {
          this.formApiRef.current = form;
          return (
            <form
              className={classnames('custom-fields-form', 'scope-section')}
              onSubmit={(e) => e.preventDefault()}
              noValidate
            >
              <FormSpy
                subscription={{ values: true }}
                onChange={({ values }) =>
                  dispatch(setFormValues('chorusForm', values))
                }
              />
              <div className="scope-section-title pb-xs-0 pt-dt-0" />
              <div className="scope-section-fields">{this.getChorusFields()}</div>
            </form>
          );
        }}
      </Form>
    );
  }
}

ChorusFieldsForm.defaultProps = {
  initialValues: null
};

function mapStateToProps(state) {
  return {
    locale: localeSelector(state),
    m: messagesSelector(state)
  };
}

export default connect(mapStateToProps)(ChorusFieldsForm);
